"use client";
import { Suspense } from "react";
import GradientBackground from "@/components/layout/gradient-background";
import SectionLayout from "@/components/layout/section-layout/section-layout";
import ContentWrapper from "@/components/layout/content-wrapper/content-wrapper";
import PagePositioner from "@/components/layout/page-positioner/page-positioner";
import PageHeader from "@/components/layout/PageHeader";
import { EtherealPageContent } from "@/features/ethereals/EtherealPage";

export default function EtherealsPage() {
  return (
    <ContentWrapper>
      <SectionLayout>
        <PagePositioner>
          {/* extra div to  */}
          <div className="medium-section">
            <GradientBackground
              containerStyle={{ height: "150%", position: "fixed" }}
            />

            <PageHeader
              title="ethereals"
              subtitle="Your existing assets from other chains reflected on Blessnet in realtime."
              documentationLink="https://docs.bless.net/blessnet-apps/ethereals"
            />
            <Suspense fallback={<div>loading</div>}>
              <EtherealPageContent />
            </Suspense>
          </div>
        </PagePositioner>
      </SectionLayout>
    </ContentWrapper>
  );
}
